<svelte:options tag='swc-select' immutable={true} />

<script>

  import { tick } from 'svelte';
  import { get_current_component } from 'svelte/internal';
  import { initEventDispatcher } from '../helpers/init-event-dispatcher';
  import ValidationMessage from './ValidationMessage.svelte';
  import Input from './Input.svelte';
  import LoadingSpinner from './LoadingSpinner.svelte';

  export let placeholder = '';
  export let value = null;
  export let options = [];
  export let validationmessage = null;
  export let isloading = false;
  export let isformpristine = true;
  export let hidevalidationonmobile = false;

  let allOptionsElement;
  let areOptionsVisible = false;
  let displayValue = '';

  const dispatch = initEventDispatcher(get_current_component());
  const onUpdate = (newValue) => dispatch('update', newValue);

  const showOptions = async () => {
    if (!options || options.length === 0) {
      return;
    }
    areOptionsVisible = true;
    await tick();
    const selected =
      allOptionsElement
        ? Array.from(allOptionsElement.children)
          .find(child => child.classList.contains('selected'))
        : null;
    if (selected) {
      selected.scrollIntoView({ block: 'center' });
    }
  };

  const hideOptions = () => {
    areOptionsVisible = false;
  };

  const onSelected = (newValue) => {
    onUpdate(newValue);
    hideOptions();
  };

  $: {
    onSelected(value);
    const selected = options.find(option => option.value === value);
    displayValue = selected ? selected.label : '';
  }

</script>

<style>
  div {
    position: relative;
    background-color: #F1F2F8;
    border-radius: 4px;
  }
  swc-input {
    margin-right: 24px;
    display: block;
  }
  svg {
    width: 10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
  }
  .input-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    opacity: 0;
    cursor: pointer;
  }
  .option-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
  }
  .all-options {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% + 50px));
    overflow-y: scroll;
    background: #FFFFFF;
    z-index: 1;
    min-width: 312px;
    width: 100%;
    max-height: 256px;
    border-radius: 4px;
    box-shadow: 0 2px 4px -1px rgba(0,0,0,.2),
      0 4px 5px 0 rgba(0,0,0,.14),
      0 1px 10px 0 rgba(0,0,0,.12);
  }
  .option {
    cursor: pointer;
    font-size: 1em;
    padding: 13px 16px;
    width: 100%;
    border: none;
    background: none;
    text-align: left;
    font-family: inherit;
    color: inherit;
    letter-spacing: 0.32px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    outline: none;
  }
  .option:focus {
    border-radius: 2px;
    outline: 1px solid #111155;
  }
  .option:hover {
    background-color: rgba(0, 0, 0, .04)
  }
  .option.selected {
    background: rgba(0,0,0,.12);
  }
  swc-loading-spinner {
    position: absolute;
    top: 17px;
    right: 13px;
    width: 20px;
    background-color: #F1F2F8;
  }

  @media (min-width: 768px) {
    svg {
      width: 16px;
    }
  }
</style>

<div>

  <swc-input
    validationmessage={validationmessage}
    value={displayValue}
    placeholder={placeholder}
    isformpristine={isformpristine}
    settabindex={-1}
    hidevalidationonmobile={hidevalidationonmobile}
    hideborder={true} />
  <svg viewBox='0 0 16 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1.1167 1.53219L8.10073 8.51622L15.1167 1.50024' stroke='#111155' stroke-width='1.5'/>
  </svg>
  <button class='input-overlay'
    data-e2e-id='select-btn'
    on:click={showOptions}></button>
  {#if areOptionsVisible}
    <div class='option-overlay' on:click={hideOptions}></div>
    <div class='all-options' bind:this={allOptionsElement}>
      {#each options as option}
        <button class='option'
          data-e2e-id='option'
          class:selected={value === option.value}
          on:click={() => onSelected(option.value)}>{option.label}</button>
      {/each}
    </div>
  {/if}
  {#if isloading}
    <swc-loading-spinner data-e2e-id='loading' />
  {/if}

</div>
